export const VAL_REMARKS = "valRemarks";
export const INSIDE_SURVEY_ADDRESS_INFO = "addressInfo";
export const INSIDE_SURVEY_PHOTO = "photo";
export const INSIDE_SURVEY_CABLING_PROPOSAL = "cablingProposal";
export const INSIDE_SURVEY_OUTSIDE_UNITS = "outsideUnits";
export const INSIDE_SURVEY_INSIDE_UNITS = "insideUnits";
export const INSIDE_SURVEY_OUTSIDE_TECHNICAL_INFO = "outsideTechnicalInfo";
export const INSIDE_SURVEY_INSIDE_TECHNICAL_INFO = "insideTechnicalInfo";
export const INSIDE_SURVEY_CONTACT_INFO = "contactInfo";
export const INSIDE_SURVEY_VALIDATE = "validate";

export enum InsideSurveyPhoto {
  FACADE_PHOTO_SUBTITLE = "insideFacadePhotoSubtitle",
  FACADE_PHOTO_FIELD = "insideFacadePhotoField",
}

export enum InsideSurveyOutsideInfo {
  HEAD_OF_DISTRIBUTION_SUBTITLE = "insideOutsideInfoHeadOfDistributionSubtitle",
  MAIN_DISTRIBUTION_TYPE_FIELD = "mainDistribution",
  FACADE_HEIGHT_FIELD = "mainDistributionHeight",
  UNDERGROUND_REASON_FIELD = "mainDistributionUndergroundReason",
  LENGTH_FRONT_YARD_FIELD = "mainDistributionFrontYardLength",
  FRONT_YARD_PAVEMENT_TYPE_FIELD = "mainDistributionFrontYardPavement",
  FRONT_YARD_FIELD = "frontYard",
  PATRIMONY_FIELD = "patrimony",
  FACADE_SUBTITLE = "facadeSubtitle",
  ELECTRICITY_CABLES_FIELD = "electricityCables",
  COAX_CABLES_FIELD = "coaxCables",
  MULTITAP_FIELD = "multiTap",
  PUBLIC_LIGHTING_FIELD = "publicLightning",
  FACADE_DOUBTS = "solutionDoubt",
  FACADE_DOUBTS_REMARK = "solutionDoubtRemark",
  STREET_SUBTITLE = "streetSubtitle",
  STREET_FURNITURE_QUESTION_FIELD = "streetFurnitureQuestion",
  STREET_FURNITURE_FIELD = "streetFurniture",
  OTHER_OBSTRUCTION_QUESTION_FIELD = "otherObstructionQuestion",
  OTHER_OBSTRUCTION_FIELD = "otherObstruction",
  PAVING_FOOTPATH_FIELD = "pavingFootpath",
  FRONT_YARD_PICTURES_SUBTITLE = "frontYardPicturesSubtitle",
  FRONT_YARD_PICTURES_FIELD = "frontYardPictures",
}

export enum InsideSurveyInsideInfo {
  GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE = "insideInsideTechnicalGeneralTechnicalIntroductionSubtitle",
  HORIZONTAL_VERTICAL_INFO_SUBTITLE = "insideInsideTechnicalHorizontalVerticalInfoSubtitle",
  QUADRANT_FIELD = "quadrant",
  VERTICAL_SHAFT_FIELD = "verticalTechnicalShaft",
  HORIZONTAL_TECHNICAL_SHAFT_FIELD = "horizontalTechnicalShaft",
  INTRODUCTION_FIELD = "introduction",
  NUM_90_DEGREE_CORNERS_FIELD = "nrOf90DegreeCorners",
  NUM_ENDKITS_GUTTERS_FIELD = "nrOfEndKitsForGutters",
  NUMBER_GUTTERS_FIELD = "nrOfGutters",
  NUM_HORIZONTAL_DRILLING_FIELD = "nrOfHorizontalDrilling",
  NUM_INSIDE_OUTSIDE_CORNERS_FIELD = "nrOfInsideOutsideCorners",
  NUM_SEALING_KITS_DRILLING_HOLES_FIELD = "nrOfSealingKitsForDrillingHoles",
  NUM_VERTICAL_DRILLING_FIELD = "nrOfVerticalDrilling",
  ROOM_AVAILABLE_FUTURE_INTRO_BOX_FIELD = "roomAvailableForFutureIntroBox",
  SELLING_HIGHER_THAN_3_5_FIELD = "sellingHigherThan3and5m",
  ELECTRICITY_OTHER_INFO_SUBTITLE = "insideInsideTechnicalElectricityOtherInfoSubtitle",
  GENERAL_TECHNICAL_INFO_PHOTOS = "generalTechnicalInfoPhotos",
  ELECTRICITY_TELCO_ROOM_PHOTOS_FIELD = "electricityInTelcoRoomPhotos",
  ROOM_AVAILABLE_NEW_EQUIPMENT_PHOTOS_FIELD = "roomAvailableForNewEquipmentPhotos",
  CONNECTIONS_CABLING_INFO_SUBTITLE = "insideInsideTechnicalExistingTelcoConnectionsSubtitle",
  TSA_TECHNICALSOLUTION_NOT_PROVIDED = "insideInsideTechnicalInfoTechSolution",
  COAX_QUANTITY_FIELD = "existingTelcoCoaxQuantity",
  COPPER_INTROS_SUBTITLE = "insideInsideTechnicalInfoCopperIntrosSubtitle",
  OUTSIDE_COPPER_INTROS_FIELD = "outsideCopperIntroPhotos",
  INSIDE_COPPER_INTROS_FIELD = "insideCopperIntroPhotos",
  DESIRED_FIBER_SUBTITLE = "insideInsideTechnicalInfoDesiredFiberIntro",
  OUTSIDE_DESIRED_FIBER_FIELD = "outsideFibreIntroPhotos",
  INSIDE_DESIRED_FIBER_FIELD = "insideFibreIntroPhotos",
  TELCO_ROOM_SUBTITLE = "insideInsideTechnicalInfoTelcoRoomSubtitle",
  TELCO_ROOM_PHOTO_FIELD = "telcoRoomPhotos",
  PROXIMUS_EQUIPMENT_SUBTITLE = "insideInsideTechnicalInfoProximusEquipmentSubtitle",
  PROXIMUS_EQUIPMENT_PHOTO_FIELD = "proximusEquipmentPhotos",
  VERTICAL_PHOTO_SUBTITLE = "verticalShaftPhotoSubtitle",
  ELECTRICITY_PHOTO_SUBTITLE = "electricityPhotoSubtitle",
}

export enum InsideSurveyCablingProposal {
  PHOTO_GENERAL_SUBTITLE = "insideCablingPhotoGeneralSubtitle",
  PHOTO_GENERAL_FIELD = "generalPhotos",
  OUTSIDE_INTRO_PHOTO_SUBTITLE = "insideCablingPhotoOutsideIntroSubtitle",
  OUTSIDE_INTRO_PHOTO_FIELD = "outsideIntroPhotos",
  FACADE_PHOTO_SUBTITLE = "insideCablingPhotoFacadeSubtitle",
  FACADE_PHOTO_FIELD = "facadePhotos",
  UNDERGROUND_PHOTO_SUBTITLE = "insideCablingPhotoUndergroundSubtitle",
  UNDERGROUND_PHOTO_FIELD = "undergroundPhotos",
  FLOOR_PLAN_PHOTO_SUBTITLE = "insideCablingPhotoFloorPlanSubtitle",
  FLOOR_PLAN_PHOTO_FIELD = "floorPlanPhotos",
  BUILDING_LAYOUT_SUBTITLE = "insideCablingBuildingLayoutSubtitle",
  BUILDING_LAYOUT_FIELD = "buildinglayoutField",
}

export enum InsideSurveyOutsideUnits {
  BUILDING_CHARACTERISTIC_FIELD = "buildingType",
  UNITS_FIELD = "numberOfUnitsField",
  NUMBER_OF_ROOMS_FIELD = "generalNumberOfRoomsField",
  FLOORS_FIELD = "floorsField",
}

export enum InsideSurveyInsideUnits {
  FLOORS_FIELD = "floorsField",
}
